module.exports = __webpack_public_path__ + "img/СберЗвук.3139eed9.png";